import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Loading placeholder matching the user-management layout: the header plus a
 * full-width users-list skeleton.
 */
export function UserManagementSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      <div className="space-y-2">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-4 w-72" />
      </div>
      <div className="flex w-full flex-col gap-2">
        {Array.from({ length: 6 }, (_, i) => i).map((i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton className="size-8 rounded-full" />
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-3.5 w-40" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
